import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { validateRootChartUrl } from './helpers';

const CHART_URL_INPUT_PREFIX =
    'support.chartsTemplates.createOrEditModal.chartUrlInput';

const StyRootChartSectionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(5),
}));

const StyTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.paper,
    },
}));

type ChartURLInputStepProps = {
    rootUrlInputValue: string;
    setRootUrlInputValue: (arg: string) => void;
};

const ChartURLInputStep = ({
    rootUrlInputValue,
    setRootUrlInputValue,
}: ChartURLInputStepProps) => {
    const { t } = useTranslation();
    const isUsingErrorFormat =
        !!rootUrlInputValue && !validateRootChartUrl(rootUrlInputValue);
    return (
        <StyRootChartSectionContainer>
            <StyTextField
                error={isUsingErrorFormat}
                fullWidth
                label={t(`${CHART_URL_INPUT_PREFIX}.placeholder`)}
                helperText={
                    isUsingErrorFormat
                        ? t(`${CHART_URL_INPUT_PREFIX}.invalidUrl`)
                        : undefined
                }
                value={rootUrlInputValue}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setRootUrlInputValue(event.target.value as string);
                }}
                variant="outlined"
            />
        </StyRootChartSectionContainer>
    );
};

export default ChartURLInputStep;
